<template>
  <ParksDetail />
</template>

<script>
import ParksDetail from '@/components/Pages/Parks/Detail/Detail.vue'

export default {
  components : {
    ParksDetail
  }
}
</script>

<style lang="scss">

</style>